import React from "react";
import ReactDOM from "react-dom";

const offScreenLiveRegion: React.CSSProperties = {
    position: "absolute",
    left: "-10000px",
    width: "1px",
    height: "1px",
    overflow: "hidden",
};

export interface PoliteStatusPortalProps {
    children: React.ReactNode;
    /** Optional class on the off-screen live region, e.g. to target a specific instance (several components render one). */
    className?: string;
}

/**
 * Polite status updates rendered at document.body. Screen readers often fail to announce
 * aria-live inside tables or under nested regions; portaling avoids that.
 */
export function PoliteStatusPortal(props: PoliteStatusPortalProps) {
    if (typeof document === "undefined") {
        return null;
    }

    return ReactDOM.createPortal(
        <div role="status" aria-live="polite" aria-atomic="true" className={props.className} style={offScreenLiveRegion}>
            {props.children}
        </div>,
        document.body,
    );
}
